import React, { useState, useContext, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";

import randomIntervalList from "ui/hooks/randomIntervalList";

import { getRecentCandidates } from "../../verticals/services";

import { ThemeContext } from "../../context/ThemeContext";

import RecentTableDisplay from "./RecentTableDisplay";
import VerticalSubCatDisplay from "./VerticalSubCatDsiplay";


const RecentCandidatesDisplay = ({ vertical, showSubcatPicker, showHeader, className }) => {
    const [ serverCandidates , setCandidates ] = useState([]);
    const displayCandidates = randomIntervalList( serverCandidates, 50, 12 );
    const [ activeSubCat , setActiveSubcat ] = useState("");
    const context = useContext( ThemeContext );

    const handleSubcatPick = ( subCat ) =>{
        setActiveSubcat( subCat );
    }

    useEffect( ()=> {
        const candidateSubscription = getRecentCandidates(vertical ? vertical.catIds : [], vertical ? vertical.subcatKeyword[activeSubCat] : "" ).subscribe(
            ( data ) => {
                setCandidates( data.candidates );
            }
        );
        return () => {
            candidateSubscription.unsubscribe();
        }
    },[activeSubCat]);

    

    return (
        <section className={ ( className ? className : "" ) + " recent_table_display "+( context ? "recent_table_display_"+context : "" )}>
            <Container>
                { showSubcatPicker && <VerticalSubCatDisplay vertical={vertical.name} subCatCount={vertical.subCatCount} subCategories={vertical.subCategories} 
                    handleSubCat={handleSubcatPick} active={activeSubCat}
                ></VerticalSubCatDisplay> }
                <div className="recent_content_holder">
                    {showHeader && <header className="d-none d-lg-block shadow-none recent_table_item">
                        <Row noGutters>
                            <Col md="3" >Name</Col>
                            <Col md="4" >Work Experience</Col>
                            <Col md="3" >Location</Col>
                            <Col md="2" >Applied</Col>
                        </Row>
                    </header>}
                    <div style={{ "margin": "-10px -18px" }}><PerfectScrollbar suppressScrollX style={{ "height": "275px", "padding": "0 28px 0px 18px", "marginTop" : "10px" }}>
                        <RecentTableDisplay items={displayCandidates} ></RecentTableDisplay>
                    </PerfectScrollbar></div>
                </div>
            </Container>
        </section>
    )
}

export default RecentCandidatesDisplay;